export default "__VITE_ASSET__OvMU7BMa__"